import type { HoursMinutes } from '../types/RoutineTimeline.types';
import { MS_PER_MINUTE } from './constants';
import type { Optional } from 'lib/types/Optional';

const MINUTES_PER_HOUR = 60;

/** Whole hours and the minutes left over; the duration is rounded to the nearest minute. */
export const splitHoursMinutes = (milliseconds: number): HoursMinutes => {
  const totalMinutes = Math.round(milliseconds / MS_PER_MINUTE);

  return { hours: Math.floor(totalMinutes / MINUTES_PER_HOUR), minutes: totalMinutes % MINUTES_PER_HOUR };
};

/** "1h 30m", "2h" or "45m"; undefined when there is no duration. */
export const formatDurationShort = (milliseconds: Optional<number>): string | undefined => {
  if (milliseconds == null) {
    return undefined;
  }

  const { hours, minutes } = splitHoursMinutes(milliseconds);

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  }

  return hours > 0 ? `${hours}h` : `${minutes}m`;
};
